import React from "react";
import { motion } from "framer-motion";

const Challenges = () => {
  const audience = [
    {
      icon: "🎤",
      description: "Aspiring singers who only hum melodies"
    },
    {
      icon: "📝",
      description: "Songwriters stuck with unfinished lyrics"
    },
    {
      icon: "❤️",
      description: "Passionate music lovers who never got guidance"
    },
    {
      icon: "✨",
      description: "Creators who feel \"talent hai, process nahi\""
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="max-w-5xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Who This Is For
          </h2>
          
          <div className="space-y-4 text-xl text-gray-700 mb-12">
            <p className="font-semibold">You don't need a music degree.</p>
            <p className="font-semibold">You don't need a fancy studio.</p>
            <p className="font-semibold">You don't need industry contacts.</p>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <h3 className="text-2xl font-bold text-center text-purple-900 mb-8">I work with:</h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {audience.map((item, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.03 }}
                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center gap-4"
              >
                <span className="text-4xl">{item.icon}</span>
                <p className="text-lg text-gray-700">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-center mt-12"
        >
          <p className="text-2xl font-semibold text-purple-900 italic">
            If music keeps calling you — you belong here.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Challenges;
